export function clstagcontent(tag) {
  const hostname = window.location.hostname
  const routerPath = this.$route.path
  const pathParams = Object.values(this.$route.params)
  const router = routerPath
    .split('/')
    .filter(path => !pathParams.includes(path))
    .join('/')
  const clstag = `${hostname}|keycount|${router}|${tag}`
  return clstag
}
